import { c as _c } from "react/compiler-runtime";
import { IconArchive, IconArrowRight, IconConfetti } from "@tabler/icons-react";
import Link from "next/link";
import { Button } from "@domainstack/ui/button";
import { Empty, EmptyContent, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from "@domainstack/ui/empty";
interface NotificationEmptyStateProps {
  variant: "inbox" | "archive";
  onClosePopover?: () => void;
}
export function NotificationEmptyState(t0) {
  const $ = _c(16);
  const {
    variant,
    onClosePopover
  } = t0;
  let t1;
  if ($[0] !== variant) {
    t1 = <EmptyMedia variant="icon">{variant === "inbox" ? <IconConfetti /> : <IconArchive />}</EmptyMedia>;
    $[0] = variant;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = variant === "inbox" ? "All caught up!" : "Nothing archived yet";
  let t3;
  if ($[2] !== t2) {
    t3 = <EmptyTitle>{t2}</EmptyTitle>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = variant === "inbox" ? "No unread notifications" : "Nothing to see here (yet\u2026)";
  let t5;
  if ($[4] !== t4) {
    t5 = <EmptyDescription>{t4}</EmptyDescription>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t1 || $[7] !== t3 || $[8] !== t5) {
    t6 = <EmptyHeader>{t1}{t3}{t5}</EmptyHeader>;
    $[6] = t1;
    $[7] = t3;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <IconArrowRight className="size-3" />;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== onClosePopover) {
    t8 = <EmptyContent><Button variant="link" className="text-[13px]" nativeButton={false} aria-label="Go to dashboard" render={<Link href="/dashboard" onNavigate={onClosePopover}>Go to dashboard{t7}</Link>} /></EmptyContent>;
    $[11] = onClosePopover;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t6 || $[14] !== t8) {
    t9 = <Empty className="p-10 md:p-10">{t6}{t8}</Empty>;
    $[13] = t6;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
}